(function () {
  'use strict';

  var PROPERTY_KEY = 'Your Name';
  var PROPERTY_STYLE = 'Style';
  var isBound = false;

  var pendingPersonalization = null;
  var cartSnapshotBeforeAdd = null;
  var propertyApplyTimer = null;
  var propertyApplyAttempts = 0;
  var MAX_PROPERTY_APPLY_ATTEMPTS = 40;
  var isInjecting = false;
  var isRefreshingCart = false;
  var isProcessingAdd = false;
  var isApplyingProperties = false;
  var isAddingAddons = false;

  function getOfferRoot() {
    return (
      document.querySelector('.omg-offer') ||
      document.querySelector('.otTableOffer .omg-offer') ||
      document.querySelector('.otTableOffer')
    );
  }

  function getProductVariants() {
    if (window.meta && window.meta.product && window.meta.product.variants) {
      return window.meta.product.variants;
    }

    var select = document.querySelector('[id^="ProductSelect-"]');
    if (!select) return [];

    return Array.prototype.map.call(select.options, function (option) {
      var label = option.textContent.trim();
      var title = label.split(' - ')[0].trim();
      return {
        id: parseInt(option.value, 10),
        public_title: title,
        title: title
      };
    });
  }

  function getVariantIdForColor(color) {
    if (!color) return null;

    var variants = getProductVariants();
    var i;

    for (i = 0; i < variants.length; i++) {
      if (variants[i].public_title === color || variants[i].title === color) {
        return variants[i].id;
      }
    }

    for (i = 0; i < variants.length; i++) {
      if (variants[i].name && variants[i].name.indexOf(' - ' + color) !== -1) {
        return variants[i].id;
      }
    }

    return null;
  }

  function getActiveOptionItem() {
    var checked = document.querySelector('.omg-option-item input[name="option"]:checked');
    return checked ? checked.closest('.omg-option-item') : null;
  }

  function getActivePickerRows() {
    var option = getActiveOptionItem();
    if (!option) return [];
    return Array.prototype.slice.call(option.querySelectorAll('.omg-variant-picker-row'));
  }

  function getRowColor(row) {
    var select = row.querySelector('.omg-swatch-select, select');
    return select ? select.value.trim() : '';
  }

  function getRowTemplate() {
    return document.getElementById('debaans-personalization-row-template');
  }

  function saveRowStates() {
    var states = {};
    getActivePickerRows().forEach(function (row, index) {
      var widget = row.__debaansPersonalizationWidget;
      if (widget) {
        var values = widget.getValues();
        states[index] = {
          enabled: values.enabled,
          styleId: values.style ? values.style.id : null,
          name: values.name
        };
      }
    });
    return states;
  }

  function getRowConfig() {
    var script = document.getElementById('debaans-omg-personalization-config');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function rowsNeedInjection() {
    var rows = getActivePickerRows();
    if (!rows.length) return false;

    return rows.some(function (row) {
      return !row.querySelector('.omg-personalization-field-wrap [data-debaans-personalization]');
    });
  }

  function createRowWidget(row, index) {
    var template = getRowTemplate();
    if (!template || !window.DebaansPersonalization) return null;

    var wrap = row.querySelector('.omg-personalization-field-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'omg-personalization-field-wrap';
      wrap.style.cssText = 'width:100%;margin-top:8px;flex:1 1 100%;';

      var options = row.querySelector('.omg-variant-picker-options');
      if (options) {
        options.appendChild(wrap);
      } else {
        row.appendChild(wrap);
      }

      row.style.flexWrap = 'wrap';
    }

    var existing = wrap.querySelector('[data-debaans-personalization]');
    if (!existing) {
      existing = template.content.firstElementChild.cloneNode(true);
      existing.id = 'omg-personalization-row-' + index;

      var configScript = document.createElement('script');
      configScript.type = 'application/json';
      configScript.setAttribute('data-personalization-config', '');
      configScript.textContent = JSON.stringify(getRowConfig() || {});
      existing.appendChild(configScript);

      wrap.innerHTML = '';
      wrap.appendChild(existing);
    }

    if (!existing.__debaansPersonalization) {
      existing.__debaansPersonalization = window.DebaansPersonalization.create(existing);
    }

    row.__debaansPersonalizationWidget = existing.__debaansPersonalization;
    return row.__debaansPersonalizationWidget;
  }

  function injectPersonalizationFields() {
    if (isInjecting || !rowsNeedInjection()) return;

    isInjecting = true;

    try {
      var rows = getActivePickerRows();
      if (!rows.length) return;

      var saved = saveRowStates();

      rows.forEach(function (row, index) {
        var widget = createRowWidget(row, index);
        if (widget && saved[index]) {
          widget.restore(saved[index]);
        }
      });
    } finally {
      isInjecting = false;
    }
  }

  function collectLineItemData() {
    injectPersonalizationFields();

    return getActivePickerRows().map(function (row, index) {
      var color = getRowColor(row);
      var widget = row.__debaansPersonalizationWidget;
      var values = widget ? widget.getValues() : { enabled: false, name: '', styleLabel: '' };

      return {
        variantId: getVariantIdForColor(color),
        color: color,
        name: values.enabled ? values.name : '',
        style: values.enabled && values.style ? values.style.label : '',
        addonVariantId:
          values.enabled && values.style ? values.style.addonVariantId : null,
        enabled: values.enabled,
        index: index
      };
    });
  }

  function validatePersonalization(data) {
    if (!data.length) return false;

    for (var i = 0; i < data.length; i++) {
      var row = getActivePickerRows()[i];
      var widget = row && row.__debaansPersonalizationWidget;

      if (widget && !widget.validate(i + 1)) {
        return false;
      }

      if (!data[i].variantId) {
        alert('Please select a color for item #' + (i + 1) + ' before adding to cart.');
        return false;
      }
    }

    return true;
  }

  function shouldHandleOmgAdd() {
    return !!getOfferRoot() && getActivePickerRows().length > 0;
  }

  function fetchCart() {
    if (window.jQuery) {
      return new Promise(function (resolve, reject) {
        window.jQuery
          .getJSON('/cart.js')
          .done(resolve)
          .fail(function (xhr) {
            reject(xhr.responseJSON || { description: xhr.statusText || 'Cart fetch failed' });
          });
      });
    }

    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.json();
    });
  }

  function getSnapshotKeys(cart) {
    var keys = {};
    if (!cart || !cart.items) return keys;
    cart.items.forEach(function (item) {
      keys[item.key] = true;
    });
    return keys;
  }

  function changeLineItemProperties(lineKey, quantity, properties) {
    var payload = {
      id: lineKey,
      quantity: quantity,
      properties: properties
    };

    if (window.jQuery) {
      return new Promise(function (resolve, reject) {
        window.jQuery
          .ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: JSON.stringify(payload),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json'
          })
          .done(resolve)
          .fail(function (xhr) {
            reject(xhr.responseJSON || { description: xhr.statusText || 'Cart update failed' });
          });
      });
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json();
    });
  }

  function getEnabledPendingItems() {
    if (!pendingPersonalization) return [];
    return pendingPersonalization.filter(function (item) {
      return item.enabled && item.name && item.addonVariantId;
    });
  }

  function isAddonVariant(variantId) {
    if (window.DebaansPersonalization && window.DebaansPersonalization.isAddonVariant) {
      return window.DebaansPersonalization.isAddonVariant(variantId);
    }
    return false;
  }

  function getAddonsStillNeeded(cart) {
    var enabledItems = getEnabledPendingItems();
    if (!enabledItems.length) return [];

    var stillNeeded = enabledItems.map(function (item) {
      return {
        enabled: true,
        addonVariantId: item.addonVariantId,
        name: item.name
      };
    });

    if (!cart || !cart.items) return stillNeeded;

    cart.items.forEach(function (line) {
      if (!isAddonVariant(line.variant_id)) return;

      for (var i = 0; i < stillNeeded.length; i++) {
        var pending = stillNeeded[i];
        if (
          Number(line.variant_id) === Number(pending.addonVariantId) &&
          line.properties &&
          line.properties[PROPERTY_KEY] === pending.name
        ) {
          stillNeeded.splice(i, 1);
          break;
        }
      }
    });

    return stillNeeded;
  }

  function allAddonsApplied(cart) {
    return getAddonsStillNeeded(cart).length === 0;
  }

  function finishPersonalization(cart) {
    if (!allPropertiesApplied(cart)) {
      return Promise.resolve(false);
    }

    if (allAddonsApplied(cart)) {
      clearPendingState();
      refreshMiniCart();
      return Promise.resolve(true);
    }

    if (isAddingAddons) {
      return Promise.resolve(false);
    }

    if (!window.DebaansPersonalization || !window.DebaansPersonalization.addPersonalizationAddons) {
      return Promise.resolve(false);
    }

    var addonsToAdd = getAddonsStillNeeded(cart);
    if (!addonsToAdd.length) {
      clearPendingState();
      refreshMiniCart();
      return Promise.resolve(true);
    }

    isAddingAddons = true;

    return window.DebaansPersonalization.addPersonalizationAddons(addonsToAdd)
      .then(function () {
        return fetchCart();
      })
      .then(function (updatedCart) {
        if (allAddonsApplied(updatedCart)) {
          clearPendingState();
          refreshMiniCart();
          return true;
        }
        return false;
      })
      .catch(function () {
        return false;
      })
      .finally(function () {
        isAddingAddons = false;
      });
  }

  function clearPendingState() {
    pendingPersonalization = null;
    cartSnapshotBeforeAdd = null;
    isProcessingAdd = false;
    stopPropertyApplication();
  }

  function allPropertiesApplied(cart) {
    if (!pendingPersonalization || !pendingPersonalization.length) return true;

    var snapshotKeys = cartSnapshotBeforeAdd ? getSnapshotKeys(cartSnapshotBeforeAdd) : {};
    var newLines = cart.items.filter(function (item) {
      return !snapshotKeys[item.key];
    });

    if (!newLines.length) return false;

    var pendingByVariant = {};
    pendingPersonalization.forEach(function (item, index) {
      if (!item.enabled || !item.name) return;
      var variantId = String(item.variantId);
      if (!pendingByVariant[variantId]) pendingByVariant[variantId] = [];
      pendingByVariant[variantId].push(item);
    });

    var usedPending = {};

    return newLines.every(function (line) {
      var pool = pendingByVariant[String(line.variant_id)];
      if (!pool || !pool.length) return true;

      var pending = null;
      for (var i = 0; i < pool.length; i++) {
        var key = pool[i].index;
        if (!usedPending[key]) {
          pending = pool[i];
          usedPending[key] = true;
          break;
        }
      }

      if (!pending) return true;
      return line.properties && line.properties[PROPERTY_KEY] === pending.name;
    });
  }

  function applyPendingProperties(cart) {
    if (!pendingPersonalization || !pendingPersonalization.length) {
      return Promise.resolve(false);
    }

    if (isApplyingProperties || isAddingAddons) {
      return Promise.resolve(false);
    }

    isApplyingProperties = true;

    var snapshotKeys = cartSnapshotBeforeAdd ? getSnapshotKeys(cartSnapshotBeforeAdd) : {};
    var newLines = cart.items.filter(function (item) {
      return !snapshotKeys[item.key];
    });

    if (!newLines.length) {
      isApplyingProperties = false;
      return Promise.resolve(false);
    }

    if (allPropertiesApplied(cart) && allAddonsApplied(cart)) {
      isApplyingProperties = false;
      clearPendingState();
      refreshMiniCart();
      return Promise.resolve(true);
    }

    if (allPropertiesApplied(cart) && !allAddonsApplied(cart)) {
      return finishPersonalization(cart).finally(function () {
        isApplyingProperties = false;
      });
    }

    var pendingByVariant = {};
    pendingPersonalization.forEach(function (item) {
      if (!item.enabled || !item.name) return;
      var variantId = String(item.variantId);
      if (!pendingByVariant[variantId]) pendingByVariant[variantId] = [];
      pendingByVariant[variantId].push(item);
    });

    var usedPending = {};
    var changes = [];

    newLines.forEach(function (line) {
      var pool = pendingByVariant[String(line.variant_id)];
      if (!pool || !pool.length) return;

      var pending = null;
      for (var i = 0; i < pool.length; i++) {
        var key = pool[i].index;
        if (!usedPending[key]) {
          pending = pool[i];
          usedPending[key] = true;
          break;
        }
      }

      if (!pending) return;

      var currentValue = line.properties && line.properties[PROPERTY_KEY];
      if (currentValue === pending.name) return;

      var properties = Object.assign({}, line.properties || {});
      properties[PROPERTY_KEY] = pending.name;
      if (pending.style) {
        properties[PROPERTY_STYLE] = pending.style;
      }
      changes.push(changeLineItemProperties(line.key, line.quantity, properties));
    });

    if (!changes.length) {
      if (allPropertiesApplied(cart)) {
        return finishPersonalization(cart).finally(function () {
          isApplyingProperties = false;
        });
      }
      isApplyingProperties = false;
      return Promise.resolve(false);
    }

    return Promise.all(changes)
      .then(function () {
        return fetchCart();
      })
      .then(function (updatedCart) {
        return finishPersonalization(updatedCart);
      })
      .catch(function () {
        return false;
      })
      .finally(function () {
        isApplyingProperties = false;
      });
  }

  function stopPropertyApplication() {
    if (propertyApplyTimer) {
      window.clearInterval(propertyApplyTimer);
      propertyApplyTimer = null;
    }
    propertyApplyAttempts = 0;
  }

  function startPropertyApplication() {
    stopPropertyApplication();

    propertyApplyTimer = window.setInterval(function () {
      propertyApplyAttempts += 1;

      if (!pendingPersonalization) {
        stopPropertyApplication();
        return;
      }

      if (propertyApplyAttempts > MAX_PROPERTY_APPLY_ATTEMPTS) {
        stopPropertyApplication();
        return;
      }

      if (isApplyingProperties || isAddingAddons) {
        return;
      }

      fetchCart()
        .then(function (cart) {
          return applyPendingProperties(cart);
        })
        .then(function (done) {
          if (done) stopPropertyApplication();
        });
    }, 400);
  }

  function queuePropertyApplication(data) {
    if (isProcessingAdd) return;
    isProcessingAdd = true;

    pendingPersonalization = data;

    fetchCart()
      .then(function (cart) {
        cartSnapshotBeforeAdd = cart;
      })
      .catch(function () {
        cartSnapshotBeforeAdd = { items: [] };
      })
      .finally(function () {
        startPropertyApplication();
      });
  }

  function refreshMiniCart() {
    if (isRefreshingCart) return;
    isRefreshingCart = true;

    if (window.theme && window.theme.miniCart) {
      window.theme.miniCart.updateElements();
      window.theme.miniCart.generateCart();
    }

    var miniCart = document.querySelector('.js-mini-cart');
    if (miniCart && miniCart.getAttribute('data-cartmini') === 'true') {
      miniCart.classList.add('active');
    }

    window.setTimeout(function () {
      isRefreshingCart = false;
    }, 500);
  }

  function queuePropertyApplicationFromClick(event) {
    if (!shouldHandleOmgAdd()) return;

    var button = event.target.closest('[id^="AddToCart-"], .product-form__cart-submit');
    if (!button || button.disabled) return;

    var data = collectLineItemData();
    if (!data.length) return;

    var hasPersonalization = data.some(function (item) {
      return item.enabled;
    });

    if (!hasPersonalization) return;

    if (!validatePersonalization(data)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return;
    }

    queuePropertyApplication(data);
  }

  function handleOmgSubmit(event) {
    if (!shouldHandleOmgAdd()) return;

    var form = event.target;
    if (!form || !form.matches || !form.matches('form.product-form, form[action*="/cart/add"]')) {
      return;
    }

    event.preventDefault();
  }

  function onParetoCartUpdated() {
    if (!pendingPersonalization || isAddingAddons || isApplyingProperties) return;

    window.setTimeout(function () {
      if (!pendingPersonalization) return;

      fetchCart()
        .then(function (cart) {
          return applyPendingProperties(cart);
        })
        .then(function (done) {
          if (done) stopPropertyApplication();
        });
    }, 250);
  }

  function selectDefaultBuyOption(offer) {
    if (!offer || offer.getAttribute('data-debaans-buy1-default') === 'true') return;

    var buy1Input =
      offer.querySelector('input[name="option"][value="0"]') ||
      offer.querySelector('.omg-option-item input[name="option"]');

    if (!buy1Input) return;

    if (!buy1Input.checked) {
      buy1Input.click();
      buy1Input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    offer.setAttribute('data-debaans-buy1-default', 'true');
  }

  function bindOfferEvents(offer) {
    offer.addEventListener('change', function (event) {
      if (
        event.target.matches('input[name="option"]') ||
        event.target.matches('.omg-swatch-select, select')
      ) {
        window.setTimeout(injectPersonalizationFields, 150);
      }
    });

    offer.addEventListener('click', function (event) {
      if (event.target.closest('.omg-option-item')) {
        window.setTimeout(injectPersonalizationFields, 200);
      }
    });
  }

  function bindAddToCart() {
    if (isBound) return;
    isBound = true;

    document.addEventListener('click', queuePropertyApplicationFromClick, true);
    document.addEventListener('submit', handleOmgSubmit, true);
    window.addEventListener('pareto:cart:updated', onParetoCartUpdated);
  }

  function init() {
    var offer = getOfferRoot();
    if (!offer) return false;
    if (offer.getAttribute('data-debaans-personalization-ready') === 'true') return true;

    offer.setAttribute('data-debaans-personalization-ready', 'true');
    bindOfferEvents(offer);
    bindAddToCart();
    selectDefaultBuyOption(offer);
    window.setTimeout(function () {
      selectDefaultBuyOption(offer);
      injectPersonalizationFields();
    }, 300);
    return true;
  }

  function waitForOffer() {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (init()) {
        window.clearInterval(timer);
        return;
      }
      if (attempts > 40) {
        window.clearInterval(timer);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForOffer);
  } else {
    waitForOffer();
  }
})();
